import React, { useEffect, useState, useContext } from "react";
// import "./style/dataLog.css";
import { Table, Pagination, Tag, IconButton } from "rsuite";
import { ThemeContext } from "../../../context/ThemeContext";
import CollaspedOutlineIcon from "@rsuite/icons/CollaspedOutline";
import ExpandOutlineIcon from "@rsuite/icons/ExpandOutline";
const { Column, HeaderCell, Cell } = Table;

const AllEnergyMeterDataLog = ({
  tableData,
  setActivePage,
  setDataView,
  activePage,
  totalDataCount,
  tableLoading,
}) => {
  const theme = useContext(ThemeContext);
  const [limit, setLimit] = React.useState(10);

  // const [page, setPage] = React.useState(4);
  const [totalData, setTotalData] = useState(totalDataCount);

  const handleChangeLimit = (dataKey) => {
    setLimit(dataKey);
    setActivePage(1);
    setDataView(dataKey);
  };
  const setActivePageHandler = (dataKey) => {
    setActivePage(dataKey);
  };
  useEffect(() => {
    setTotalData(totalDataCount);
  }, [totalDataCount]);

  let data = [...tableData];
  const loadingHandler = () => {
    // return true;
    // return setTimeout(myGreeting, 100);
    // function myGreeting(){
    //   return true;
    // }
    return false;
  };

  return (
    <div className="theme-background theme-text">
      <Table
        // loading={tableData.length > 0 ? false : true}
        loading={tableLoading ? true : false}
        height={500}
        data={data}
        renderEmpty={() => {
          return <div className="rs-table-body-info">No Data Available</div>;
        }}

        // autoHeight
        // wordWrap
        // className={`${theme} `}
      >
        <Column
          width={80}
          align="center"
          fixed
          className={`theme-text theme-table-background`}
        >
          <HeaderCell>Id</HeaderCell>
          <Cell dataKey="id" />
        </Column>

        <Column
          width={80}
          align="center"
          className={`theme-text theme-table-background`}
          flexGrow={1}
          fullText
        >
          <HeaderCell>Device Code </HeaderCell>
          <Cell dataKey="device_code" />
        </Column>
        <Column
          width={80}
          align="center"
          className={`theme-text theme-table-background`}
          flexGrow={1}
          fullText
        >
          <HeaderCell>Meter Id</HeaderCell>
          <Cell dataKey="meter_id" />
        </Column>
        <Column
          width={80}
          align="center"
          className={`theme-text theme-table-background`}
          flexGrow={1}
          fullText
        >
          <HeaderCell>Meter Type</HeaderCell>
          <Cell dataKey="meter_name" />
        </Column>
        <Column
          width={80}
          align="center"
          className={`theme-text theme-table-background`}
          flexGrow={1}
          fullText
        >
          <HeaderCell>Active Energy</HeaderCell>
          <Cell dataKey="active_energy_consumption" />
        </Column>
        <Column
          width={80}
          align="center"
          className={`theme-text theme-table-background`}
          flexGrow={1}
          fullText
        >
          <HeaderCell>Apparent Energy</HeaderCell>
          <Cell dataKey="apparent_energy_consumption" />
        </Column>
        <Column
          width={80}
          align="center"
          className={`theme-text theme-table-background`}
          flexGrow={1}
          fullText
        >
          <HeaderCell>Reactive Energy</HeaderCell>
          <Cell dataKey="reactive_energy_consumption" />
        </Column>

        <Column
          width={170}
          align="center"
          flexGrow={1}
          className={`theme-text theme-table-background`}
          fullText
        >
          <HeaderCell>Time</HeaderCell>
          <Cell dataKey="date" />
        </Column>
      </Table>
      <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="lg"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={totalData}
          // total={10}
          limitOptions={[10, 30, 50, 100, 200]}
          limit={limit}
          // activePage={page}
          // onChangePage={setPage}
          activePage={activePage}
          onChangePage={setActivePageHandler}
          onChangeLimit={handleChangeLimit}
          // onChangePage={handlePageChange}
          className={`theme-text`}
        />
      </div>
      {/* <Pagination
        prev
        last
        next
        first
        size="lg"
        total={totalDataCount}
        limit={limit}
        maxButtons={5}
        activePage={activePage}
        onChangePage={setActivePage}
        boundaryLinks
      /> */}
    </div>
  );
};
export default AllEnergyMeterDataLog;
